module.exports = __webpack_public_path__ + "img/conected.70e946ef.gif";